<template>
	<div>
		<div class="confirmation-container">
			<h3>Confirm Recipient List</h3>
			<span data-test="confirmation-message">
				You are sending this email to
				{{ totalSelectedContacts }} contacts. Are you sure you want to
				continue?
			</span>
		</div>
		<OverviewModalFooter
			:success="success"
			:waiting="waiting"
			:isSaveModal="true"
			@handleClick="handleSendEmail"
			@close="handleCancel"
			primaryButtonName="Send"
		/>
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import OverviewModalFooter from '@/views/client-connect-v2/modals/OverviewModalFooter.vue';

export default {
	name: 'SendAllConfirmation',
	props: {
		selectAllMode: Boolean,
		selectedLeadsCount: Number,
		success: Boolean,
		totalCount: Number,
		waiting: Boolean,
	},
	components: {
		OverviewModalFooter,
	},
	computed: {
		totalSelectedContacts() {
			return this.selectAllMode
				? this.totalCount - this.selectedLeadsCount
				: this.selectedLeadsCount;
		},
	},
	methods: {
		...mapActions(['setSendAllConfirmation']),
		handleSendEmail() {
			this.$emit('handleSendEmail');
		},
		handleCancel() {
			this.setSendAllConfirmation(false);
		},
	},
};
</script>

<style lang="scss" scoped>
.confirmation-container {
	display: flex;
	flex-direction: column;
	@include rem('margin', 20px auto 20px auto);
	width: 80%;
	justify-content: center;
	align-items: flex-start;
	h3 {
		font-weight: 600;
	}
}
</style>
